<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Audito veiksmai') }}</h1>
    <!-- search -->
    <admin-audits-data-search @downloadReport="downloadReport" :loading="loading" @searchAudit="dataAuditSearch" />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.action_type`]="{ item }">
        <el-table-enum enumName="ActionTypes" :item="item.action_type" />
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import AdminAuditsDataSearch from './AdminAuditsDataSearch'
import userRole from '@/mixins/userRole'
import { mapGetters } from 'vuex'
import math from '@/mixins/math'

export default {
  name: 'AdminAuditsData',
  components: {
    AdminAuditsDataSearch,
  },
  mixins: [userRole, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      listData: [],
      searchAuditData: {},
      applications: [
        {
          title: 'Įreg api',
          key: 'ireg',
          active: false,
        },
        {
          title: 'Broker api',
          key: 'broker',
          active: true,
        },
      ],
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    ...mapGetters(['listParams']),
    headers() {
      return [
        {
          text: this.$t('Nr'),
          align: 'start',
          value: 'id',
        },
        {
          text: this.$t('Įvykio data'),
          align: 'start',
          value: 'created_at',
        },
        {
          text: this.$t('Įvykio tipas'),
          align: 'start',
          value: 'action_type',
        },
        {
          text: this.$t('Įvykis'),
          align: 'start',
          value: 'action_text',
        },
        {
          text: this.$t('Naudotojas'),
          align: 'start',
          value: 'user',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      if (!this.listData) return
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {},
  created() {
    this.setlistParams()
  },
  methods: {
    setlistParams(){
      if (this.listParams && (this.pagination.pageSize != this.listParams.pageSize) && (this.listParams.pageSize != null)) {
        this.pagination.pageSize = this.listParams.pageSize
      } 
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchAuditData,
      }

      this.$axios
        .post(`audits/list`, data)
        .then((res) => {
          this.listData = res.data.audits ?? []
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    dataAuditSearch(searchData) {
      this.searchAuditData = searchData
      this.loading = true
      this.getData(true)
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    downloadReport() {
      this.loading = true
      const data = {
        ...this.pagination,
        search: this.searchData,
        isReport: true,
      }
      this.$axios
        .post(`audits/list`, data)
        .then((res) => {
           this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
